import { ServerSettings } from "@src/infrastructure/serverSettings";
import { Browser } from "@src/infrastructure/browser";
import { routes } from "@src/infrastructure/routes";
import { HttpClient } from "@src/infrastructure/httpClient/index";
import { ErrorHandler } from "@src/infrastructure/errorHandler";
import { Log } from "@src/infrastructure/logging/log";

export class LoggingViewModel {
    private httpClient: HttpClient;
    private log: Log;
    errorHandler: ErrorHandler;
    message: KnockoutObservable<string>;
    browser: Browser;

    constructor(serverSettings: ServerSettings) {
        this.message = ko.observable('');
        this.browser = new Browser();
        this.httpClient = new HttpClient(serverSettings);
        this.errorHandler = new ErrorHandler(serverSettings);
        this.log = new Log(serverSettings);
    }

    webRequest() {
        this.browser.gotoUrl(routes.web.sandbox.throwError);
    }

    async apiRequest () {
        try {
            await this.httpClient.post(routes.api.sandbox.throwError);
        }
        catch (e) {
            this.errorHandler.handleError(e);
        }
    }

    browserError() {
        throw new Error('Hello world browser error!');
    }

    async logInformational() {
        try {
            await this.log.information('SandboxLogInfo', this.message());
        }
        catch (e) {
            this.errorHandler.handleError(e);
        }
    }
}